import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface ReviewResumeData {
    guid: string;
}

export class ReviewResume implements FormValidationModel<ReviewResumeData> {
    public data: ReviewResumeData;
    public rules: yup.Schema<ReviewResumeData>;

    public constructor() {
        this.data = {
            guid: "",
        };
        this.rules = yup.object<ReviewResumeData>().shape({
            guid: yup.string().required().label("GUID"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/careerCenter/ReviewResume.ts